module.exports = __webpack_public_path__ + "static/media/spoon.e48b8fe9.svg";